import { z } from 'zod';
import { TextItem } from './common';
export var ReasonsForLiving = z.array(TextItem).prefault([]);
